import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { validateCnpj } from './cnpj';
import { validateCpf } from './cpf';
import { detectBrazilianDocumentKind, normalizeBrazilianDocument } from './normalize';
import { CNPJ_LENGTH, CPF_LENGTH } from './types';

/** Validador Angular para CPF (11 dígitos). */
export function cpfValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const clean = normalizeBrazilianDocument(String(value));
    if (clean.length !== CPF_LENGTH) {
      return { invalidCPF: { value: control.value } };
    }

    return validateCpf(clean) ? null : { invalidCPF: { value: control.value } };
  };
}

/** Validador Angular para CPF ou CNPJ (numérico/alfanumérico). */
export function cpfCnpjValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const clean = normalizeBrazilianDocument(String(value));
    const kind = detectBrazilianDocumentKind(clean);

    if (kind === 'cpf' && clean.length === CPF_LENGTH) {
      return validateCpf(clean) ? null : { invalidCPF: { value: control.value } };
    }

    if (kind === 'cnpj' && clean.length === CNPJ_LENGTH) {
      return validateCnpj(clean) ? null : { invalidCNPJ: { value: control.value } };
    }

    if (kind === 'cnpj') {
      return { invalidCNPJ: { value: control.value } };
    }

    return { invalidCPF: { value: control.value } };
  };
}
